import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "scheduleIndexRentalContractEditFormModal" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = {
  id: "pg_check",
  class: "py-3 py-lg-4 py-xl-5"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "js-colorbox-close" }, " ", -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  id: "index",
  class: "fs-small lh-md mb-s"
}
const _hoisted_7 = {
  id: "check",
  class: "fs-small lh-md mb-s"
}
const _hoisted_8 = { id: "submit" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RentalContractForm = _resolveComponent("RentalContractForm")!
  const _component_CarChecksheetForm = _resolveComponent("CarChecksheetForm")!
  const _component_RentalContractSubmit = _resolveComponent("RentalContractSubmit")!
  const _component_BsModal = _resolveComponent("BsModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_BsModal, {
      ref: "rentalContractModalRef",
      "modal-dialog-settings": ['modal-fullscreen']
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("article", _hoisted_3, [
            _createElementVNode("div", {
              class: "close",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.hideRentalContractModal()))
            }, _hoisted_5),
            _createElementVNode("section", _hoisted_6, [
              _createVNode(_component_RentalContractForm)
            ]),
            _createElementVNode("section", _hoisted_7, [
              _createVNode(_component_CarChecksheetForm)
            ]),
            _createElementVNode("section", _hoisted_8, [
              _createVNode(_component_RentalContractSubmit)
            ])
          ])
        ])
      ]),
      _: 1
    }, 512)
  ]))
}